/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const selectAllGeos = (state: { systemSpec: any }) => state.systemSpec.geos;
export const selectNoGeo = (state: { systemSpec: any }) => state.systemSpec.noGeo;
export const selectSelectedGeo = (state: { systemSpec: any }) => state.systemSpec.selectedGeo;
export const selectEnvTypes = (state: { systemSpec: any }) => state.systemSpec.envTypes;
export const selectSelectedInstance = (state: { systemSpec: any }) => state.systemSpec.selectedInstance;